import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Pagination } from '../../interfaces/pagination/pagination.DTO';
import { ResponseBaseI } from '../../models/responseBase.interface';
import { PaginationResponseI } from '../../models/paginationResponse.interface';
import { ConsultaBandejaProgramadorI } from '../../models/consultaBandejaProgramador.interface';
import { VehiculoInternoI } from '../../models/consultaVehiculoInterno';
import { ConsultarConductoresI } from '../../models/consultarConductores';
import { CambiarEstadoVehiculoI } from '../../models/cambiarEstadoVehiculo';
import { Solicitud } from '../../interfaces/referente/SolicitudDTO';
import { GuardarVehiculoSubcontratadoDTO } from '../../interfaces/referente/GuardarVehiculoSubcontratadoDTO';
import { ConsultarInformesI } from '../../models/consultarInformes';
import { ConsultaInformeSolicitudesI } from '../../models/consultaInformeSolicitudes';

@Injectable({
  providedIn: 'root'
})
export class ProgrammerApiService {

  URI = environment.urlAPI;

  constructor(private http: HttpClient) { }

  postSolicitudConsultBandProgram(request: Pagination) {
    return this.http.post<ResponseBaseI<PaginationResponseI<ConsultaBandejaProgramadorI>>>(`${this.URI}/Solicitud/consultaBandejaProgramador`, request);
  }

  postSolicitudRelacionada(request: any) {
    return this.http.post<ResponseBaseI>(`${this.URI}/SolicitudRelacionada`, request);
  }

  postObtenerVehiculosPorClase(request: Pagination) {
    return this.http.post<ResponseBaseI<PaginationResponseI<VehiculoInternoI>>>(`${this.URI}/Vehiculo/obtenerVehiculosPorClase`, request);
  }

  postCambiarEstadoVehiculo(request: CambiarEstadoVehiculoI) {
    return this.http.post<ResponseBaseI<Solicitud>>(`${this.URI}/Vehiculo/cambiarEstadoVehiculo`, request);
  }

  postObtenerConductoresPorTipo(request: boolean) {
    return this.http.post<ResponseBaseI<ConsultarConductoresI>>(`${this.URI}/Conductor/obtenerConductoresPorTipo?BEsInterno=${request}`, null);
  }

  putActualizarVehiculoConductorSolicitud(request: any) {
    return this.http.put<ResponseBaseI>(`${this.URI}/Solicitud/actualizarVehiculoConductorSolicitud`, request);
  }

  postRegistrarVehiculoSubContratado(request: GuardarVehiculoSubcontratadoDTO) {
    return this.http.post<ResponseBaseI>(`${this.URI}/Vehiculo/registrarVehiculoSubContratado`, request);
  }

  postJSonReporteSolicitudes(request: ConsultarInformesI) {
    return this.http.post<ResponseBaseI<ConsultaInformeSolicitudesI[]>>(`${this.URI}/Reporte/json/TIP_TIPO_REPORTE_SOLICITUDES_1`, request);
  }

  postJSonReporteEncuesta(request: ConsultarInformesI) {
    return this.http.post<ResponseBaseI>(`${this.URI}/Reporte/json/TIP_TIPO_REPORTE_ENCUESTA`, request);
  }

  postExcelReporteSolicitudes(request: ConsultarInformesI) {
    return this.http.post<ResponseBaseI>(`${this.URI}/Reporte/excel/TIP_TIPO_REPORTE_SOLICITUDES_1`, request);
  }

  postExcelReporteEncuesta(request: ConsultarInformesI) {
    return this.http.post<ResponseBaseI>(`${this.URI}/Reporte/excel/TIP_TIPO_REPORTE_ENCUESTA`, request);
  }
}